export const ItemPricing = (props) => {
    const pricings = props.pricings;

    return (
        <>
            <div id="listing-pricing-list" class="listing-section">
                <h3 class="listing-desc-headline margin-top-70 margin-bottom-30">Pricing</h3>

                <div class="show-more visible">
                    <div class="pricing-list-container">

                        {!!pricings && pricings.map((pricing) => (
                            <>
                                <h4>{pricing.category}</h4>
                                <ul>
                                    {!!pricing.subcategories && pricing.subcategories.map((pricingSubcategory) => (
                                        <>
                                            <li>
                                                <h5>{pricingSubcategory.name}</h5>
                                                <p>{pricingSubcategory.description}</p>
                                                <span>{pricingSubcategory.price + ' ' + pricingSubcategory.currency}</span>
                                            </li>
                                        </>
                                    ))}
                                </ul>
                            </>
                        ))}

                    </div>
                </div>
            </div>
        </>
    )
}